import { lazy } from 'react';

import type { RouteConfig } from '@/router/types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const GpmDriveLayout = lazy(() => import('@/layouts/GpmDriveLayout'));
const GpmDriveCameraPage = lazy(() => import('@/pages/gpm-drive/camera'));
const GpmDriveAllMediaPage = lazy(() => import('@/pages/gpm-drive/all-media'));
const GpmDriveDrivePage = lazy(() => import('@/pages/gpm-drive/drive'));

const GpmDriveIndexRedirect = lazy(() => import('@/pages/gpm-drive/index'));

export const gpmDriveRoutes: RouteConfig = {
  path: '/gpm-drive',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      element: GpmDriveIndexRedirect,
    },
    {
      path: '/camera',
      layout: GpmDriveLayout,
      element: GpmDriveCameraPage,
    },
    {
      path: '/all-media',
      layout: GpmDriveLayout,
      element: GpmDriveAllMediaPage,
    },
    {
      path: '/drive',
      layout: GpmDriveLayout,
      element: GpmDriveDrivePage,
    },
  ],
};
